<template>
    <div>
        <ValidationObserver ref="addressForm">
            <b-row>
                <b-col cols="12" md="12">
                    <ValidationProvider name="address" rules="required" v-slot="{ errors }">
                        <b-form-group :label="$t('address')">
                            <b-form-textarea v-model="formData.address"
                                             rows="4"
                                             :state="errors[0] ? false : null"/>
                            <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="city" rules="required" v-slot="{ errors }">
                        <b-form-group :label="$t('city')">
                            <city-selectbox v-model="formData.city"
                                            :validateError="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="district" rules="required" v-slot="{ errors }">
                        <b-form-group :label="$t('district')">
                            <district-outline-selectbox v-model="formData.district"
                                                        :city_id="formData.city"
                                                        :validateError="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
            </b-row>
            <div class="d-flex justify-content-center">
                <b-button variant="primary"
                          @click="save"
                          :disabled="formLoading">
                    {{ $t('update') }}
                </b-button>
            </div>
        </ValidationObserver>
    </div>
</template>

<script>
    // Components
    import CitySelectbox from "@/components/interactive-fields/CitySelectbox"
    import DistrictOutlineSelectbox from "@/components/interactive-fields/DistrictOutlineSelectbox"

    // Services
    import PersonService from '@/services/PersonService'

    // Other
    import {ValidationObserver, ValidationProvider} from 'vee-validate'



    export default {
        components: {
            DistrictOutlineSelectbox,
            CitySelectbox,
            ValidationProvider,
            ValidationObserver
        },
        props: {
            personData: {
                type: Object,
            }
        },
        data() {
            return {
                formData: {},
                formLoading: false
            }
        },
        async created() {
            this.formData = {
                address: this.personData.contact_address,
                city: this.personData.contact_city_id,
                district: this.personData.contact_district_id,
            }
        },
        methods: {
            async save() {
                const isValid = await this.$refs.addressForm.validate()
                if (isValid) {
                    this.formLoading = true
                    let formData = {
                        city_id: this.formData.city,
                        district_id: this.formData.district,
                        address: this.formData.address
                    }
                    PersonService.collectContactAddress(formData).then(response => {
                        let message = response.data.message
                        this.$toast.success(this.$t('api.' + message));
                        this.$emit('addressUpdated', true)
                    }).catch(e => {
                        this.showErrors(e, this.$refs.addressForm);
                    })
                }
            },
        }
    }
</script>
